// Login.js
// import React from 'react';
// import { Link } from 'react-router-dom';

// const Login = () => {
//     // Temporary login page that doesn't use Okta yet
//     const simulateLogin = () => {
//         alert('Okta authentication will be integrated later. This is just a placeholder.');
//     };

//     return (
//         <div className="login-container">
//             <h2>Welcome to Casino Portal</h2>
//             <p>Please log in to continue</p>
//             <button
//                 className="login-button"
//                 onClick={simulateLogin}
//             >
//                 Login with Okta
//             </button>
//             <div className="back-link">
//                 <Link to="/">Back to Home</Link>
//             </div>
//         </div>
//     );
// };

// export default Login;




// Login.js
// Pages/Login.js
import React, { useEffect } from 'react';
import { useOktaAuth } from '@okta/okta-react';
import { Navigate, useLocation } from 'react-router-dom';
import '../Styles/Pages/Login.css';

const Login = () => {
    const { authState, oktaAuth } = useOktaAuth();
    const location = useLocation();

    // Get the path the user was trying to access before redirected to login
    const fromUri = location.state?.from || '/';

    // Set up the redirect URI in Okta when the component mounts
    useEffect(() => {
        if (!authState?.isAuthenticated) {
            // Store the redirect path for after successful authentication
            oktaAuth.setOriginalUri(fromUri);
        }
    }, [oktaAuth, authState, fromUri]);

    const login = async () => {
        try {
            await oktaAuth.signInWithRedirect();
        } catch (err) {
            console.error('Error during login redirect:', err);
        }
    };

    if (authState?.isAuthenticated) {
        // If user is already authenticated, redirect to the original path they were trying to access
        return <Navigate to={fromUri} />;
    }

    // Enhanced login page with styling
    return (
        <div className="login-container">
            <div className="login-card">
                <h2>Welcome to Casino Portal USA</h2>
                <p>Please log in to access the portal</p>
                <button
                    className="login-button"
                    onClick={login}
                >
                    Login with Okta
                </button>
            </div>
        </div>
    );
};

export default Login;